<template>
  <div>
    <v-autocomplete
      hide-details
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="descripcion_estado_civil"
      item-value="id_estado_civil"
      label="Estado Civil"
      persistent-hint
      return-object
      @change="$emit('input', select.id_estado_civil)"
    ></v-autocomplete>
    <v-text-field
      hide-details
      outlined
      dense
      label="Estado Civil"
      v-if="readonly===true"
      readonly
      filled
      :value="select.descripcion_estado_civil"
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
        id_estado_civil: 0,
        descripcion_estado_civil: ""
      }
    };
  },
  computed: {
    ...mapState("estadocivil", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      l.push({
        id_estado_civil: 0,
        descripcion_estado_civil: " --Seleccione-- "
      });
      return l;
    }
  },
  methods: {
    ...mapActions("estadocivil", ["set"]),
    seleccionar(id) {
      if (id) {
        let pr = this.lista.find(x => x.id_estado_civil == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    }
  }
};
</script>

<style>
</style>